// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1902": "a2792b5c","260": "ec5c5937","2669": "41eef0a1",}[chunkId] + ".css"
}